import { useContext } from 'react';
import { CurrentPregnancyChartsDataContext } from '../contexts/CurrentPregnancyChartsDataContext';

export const useCurrentPregnancyChartsDataContext = () => {
    return useContext(CurrentPregnancyChartsDataContext);
};
